import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { SupportProgressDialogComponent } from '../support-progress-dialog/support-progress-dialog.component';
import { TicketApiService } from 'src/app/services/api/ticket-api.service';

@Component({
  selector: 'app-supports-dialog',
  templateUrl: './supports-dialog.component.html',
  styleUrls: ['./supports-dialog.component.scss'],
})
export class SupportsDialogComponent implements OnInit {
  index = 1;

  constructor(
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private api: TicketApiService,
  ) {}

  ngOnInit(): void {
    this.findProblemTickets();
  }

  status(txt: string) {
    const m: any = {
      submitted: '已提交',
      processing: '处理中',
      waiting_confirmation: '待确认',
      done: '已完成',
    };
    return m[txt] || null;
  }

  checkFormDetail(id: number) {
    this.dialog.open(SupportProgressDialogComponent, {
      data: id,
      width: '665px',
      panelClass: 'app-dialog',
    });
  }

  loading = false;
  async findProblemTickets() {
    try {
      this.loading = true;
      const r = await this.api.findProblemTickets('done');
      this.data.done = r.data;
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }
}
